import { Component, OnInit } from '@angular/core';
import { Chart } from 'chart.js';
import { MessagingService } from 'src/app/shared/services/other-services/messaging.service';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { Stages } from 'src/app/shared/components/dashboard/stages/stages.component';
import { AuthServiceService } from 'src/app/shared/services/auth-service.service';
import { ClientsUsersService } from 'src/app/shared/services/other-services/clients-users.service';

export interface Totals {
  towns: number;
  stations: number;
  stages: Stages;
  clients: number;
  clientsBorrowed: number;
  clientsSaved: number;
  clientsPaid: number;
  clientsPaidInFull: number;
  clientsPaidInInstallment: number;
  deptRecovered: number;
  amountRecovered: number;
  amountUnPaid: number;
  floatAmount: number;
  loans: number;
  bodaDefaulters: number;
  taxiDefaulters: number;
  microDefaulters: number;
  bodaRecovery: number;
  taxiRecovery: number;
  microRecovery: number;
  bodaEnforcement: number;
  taxiEnforcement: number;
  microEnforcement: number;
}
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  totals: Totals = {
    towns: 12,
    stations: 10,
    stages: {boda: 5, taxi: 6},
    clients: 10,
    clientsBorrowed: 2,
    clientsSaved: 2,
    clientsPaid: 2,
    clientsPaidInFull: 2,
    clientsPaidInInstallment: 2,
    deptRecovered: 2,
    amountRecovered: 2,
    amountUnPaid: 2,
    floatAmount: 2,
    loans: 2,
    bodaDefaulters: 2,
    taxiDefaulters: 2,
    microDefaulters: 2,
    bodaRecovery: 2,
    taxiRecovery: 2,
    microRecovery: 2,
    bodaEnforcement: 2,
    taxiEnforcement: 2,
    microEnforcement: 2,
  };

  User = this.authService.loggedInUserInfo();
  inlinePlugin: any;
  textPlugin: any;
  title = 'push-notification';
  message: any;
  constructor(
    private messagingService: MessagingService,
    private authService: AuthServiceService,
    private clientUser: ClientsUsersService
  ) { }

  ngOnInit(): void {
// inline plugin
    this.messagingService.requestPermission();
    this.messagingService.receiveMessage();
    this.message = this.messagingService.currentMessage;
    this.clientUser.getTotalBodaBodaStagesByStation(this.User.userLocationId).subscribe(res => this.totals.stages.boda = res[0].numberOfBodaBodaStagesPerStation);
    this.clientUser.getTotalTaxiStagesByStation(this.User.userLocationId).subscribe(res => this.totals.stages.taxi = res[0].numberOfTaxiStagesPerStation);
    this.clientUser.getTotalClientsByStation(this.User.userLocationId).subscribe(res => this.totals.clients = res[0].numberOfCustomersPerStation);
    this.clientUser.getTotalClientsWhoBorrowedByStation(this.User.userLocationId).subscribe(res => this.totals.clientsBorrowed = res[0].numberOfCustomersBorrowedTodayPerStation);
    this.clientUser.getTotalClientsWhoSavedByStation(this.User.userLocationId).subscribe(res => this.totals.clientsSaved = res[0].numberOfCustomersSavedTodayPerStation);
    this.clientUser.getTotalClientsWhoPaidByStation(this.User.userLocationId).subscribe(res => this.totals.clientsPaid = res[0].numberOfCustomersPaidTodayByStation);
    // this.clientUser.getTotalNoOfClientPaidInFullByStation(this.User.userLocationId).subscribe(res => this.totals.clientsPaidInFull = res[0]);
    // this.clientUser.getTotalNoOfClientPaidInInstalmentByStation(this.User.userLocationId).subscribe(res => this.totals.clientsPaidInInstallment = res[0]);
    // this.clientUser.getTotalNoOfDebtsRecoveredByStation(this.User.userLocationId).subscribe(res => this.totals.deptRecovered = res[0]);
    // this.clientUser.getTotalAmountRecoveredByStation(this.User.userLocationId).subscribe(res => this.totals.amountRecovered = res[0]);
    // this.clientUser.getTotalAmountUnPaidByStation(this.User.userLocationId).subscribe(res => this.totals.amountUnPaid = res[0]);
    // this.clientUser.getTotalFloatAmountByStation(this.User.userLocationId).subscribe(res => this.totals.floatAmount = res[0]);
    // this.clientUser.getTotalLoansByStation(this.User.userLocationId).subscribe(res => this.totals.loans = res[0]);
    this.clientUser.getTotalBodaBodaLoanDefaultersByStation(this.User.userLocationId).subscribe(res => this.totals.bodaDefaulters = res[0].totalBodaBoadLoanDefaultersByStation);
    this.clientUser.getTotalTaxiLoanDefaultersByStation(this.User.userLocationId).subscribe(res => this.totals.taxiDefaulters = res[0].totalTaxiLoanDefaultersByStation);
    this.clientUser.getTotalMicroLoanDefaultersByStation(this.User.userLocationId).subscribe(res => this.totals.microDefaulters = res[0].totalMicroloanDefaultersByStation);
    this.clientUser.getTotalBodaBodaLoanRecoveryByStation(this.User.userLocationId).subscribe(res => this.totals.bodaRecovery = res[0].totalBodaBodaLoanRecoveryByStation);
    this.clientUser.getTotalTaxiLoanRecoveryByStation(this.User.userLocationId).subscribe(res => this.totals.taxiRecovery = res[0].totalTaxiLoanRecoveryByStation);
    this.clientUser.getTotalMicroLoanRecoveryByStation(this.User.userLocationId).subscribe(res => this.totals.microRecovery = res[0].totalMicrolaonRecoveryByStation);
    this.clientUser.getTotalBodaBodaLoanEnforcementByStation(this.User.userLocationId).subscribe(res => this.totals.bodaEnforcement = res[0].totalBodaBodaLoanEnforcementByStation);
    this.clientUser.getTotalTaxiLoanEnforcementByStation(this.User.userLocationId).subscribe(res => this.totals.taxiEnforcement = res[0].totalTaxiLoanEnforcementByStation);
    this.clientUser.getTotalMicroLoanEnforcementByStation(this.User.userLocationId).subscribe(res => this.totals.microEnforcement = res[0].totalMicroLoanEnforcementByStation);
  }
}
